import PageNotFound from '@/components/Statics/404';

export default [{
  name: 'pagenotfound',
  path: '*',
  components: {
    main: PageNotFound,
  },
}];



// WEBPACK FOOTER //
// ./src/router/modules/statics.js